<template>
    <div class="card card-blue">
        <div class="card-header">
            <div class="d-md-flex align-items-center">
                <div>
                    <h4 class="card-title">Warehouse</h4>
                    <h6 class="card-subtitle">All Warehouses in the Marketplace</h6>
                </div>
                <div class="ml-auto d-flex no-block align-items-center" v-if="currentOrg.role === 'ORG_ADMIN'">
                    <div class="dl">
                        <div class="button-group">
                            <router-link
                                    :to="{name: 'addmarketplacewarehouse', params: {warehouseid: currentOrg.marketplace_id}}"
                                    class="btn btn-success waves-effect waves-light">
                                <i class="fas fa-plus"></i> Add Warehouse
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="form-row">
                <div class="form-group col-md-10">
                    <div class="input-group">
                        <input class="form-control" placeholder="Search Goods and Services by Name and Description"
                               type="text"
                               v-model="search">
                        <div class="input-group-append">
                            <button @click="getWareHouses(1)" class="btn btn-light btn-outline-success font-weight-bold"
                                    type="button">
                                <i class="fa fa-search"/> Go!
                            </button>
                            <button @click="reset()"
                                    class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                    type="button">
                                <i class="fa fa-undo"/> Reset
                            </button>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-2">
                    <div class="text-right">
                        <span class="fa-xs fa-stack fa-1x ml-auto m-r-10 text-muted" title="Exporting, please wait ..."
                              v-if="exporting">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                        <div class="btn-group">
                            <button aria-expanded="false" aria-haspopup="true"
                                    class="btn waves-effect waves-light btn-outline-info dropdown-toggle"
                                    data-toggle="dropdown"
                                    type="button">
                                Operations
                            </button>
                            <div class="dropdown-menu">
                                <a @click="exportWHAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                    <i class="fa fa-file-excel"/> Export
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive" v-if="warehouses.length>0">
                <table class="table no-wrap v-top">
                    <thead>
                    <tr class="border-0 bg-light">
                        <th class="border-0 text-right"><h6>#</h6></th>
                        <th class="border-0"><h6>Name</h6></th>
                        <th class="border-0"><h6>Description</h6></th>
                        <th class="border-0"><h6>Address</h6></th>
                        <th class="border-0 text-center"><h6>Action</h6></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-bind:key="index" v-for="(w, index) in warehouses">
                        <td class="text-right">{{index + 1}}</td>
                        <td>{{w.name}}</td>
                        <td>{{w.description?w.description:"N/A" | truncate(50, '...')}}</td>
                        <td class="text-muted">
                            {{w.line1}}, <span v-if="w.line2">{{w.line2}}</span><br>
                            {{w.city}}, {{w.state}}<br>
                            {{w.postal_code}}, {{w.country}}
                        </td>
                        <td class="text-center">
                            <h6>
                                <router-link :to="{name: 'viewmarketplacewarehouse', params : { warehouseid: w.id}}">
                                    View
                                </router-link>
                                <router-link :to="{name: 'editmarketplacewarehouse', params : { warehouseid: w.id}}"
                                             class="ml-3" v-if="currentOrg.role === 'ORG_ADMIN'">
                                    Edit
                                </router-link>
                            </h6>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <template v-else>
                <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
            </template>
        </div>
        <div class="card-footer" v-if="warehouses.length>0">
            <div class="row">
                <div class="col-6">
                    <div class="form-group row">
                        <label class="col-form-label p-l-10" for="records">Display</label>
                        <div class="col-sm-2 p-t-5">
                            <select @change="perPageRecordChange()" aria-controls="lang_opt"
                                    class="form-control form-control-sm"
                                    id="records" name="lang_opt_length" v-model="perPage">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <label class="col-form-label" for="records">Records per page</label>
                    </div>
                </div>
                <div class="col-6 text-right">
                    <paginate :click-handler="pageHandler"
                              :container-class="'pagination float-right'"
                              :margin-pages="2"
                              :next-class="'page-link'"
                              :next-text="'Next'"
                              :page-class="'page-link'"
                              :page-count=pageCount
                              :page-range="3"
                              :prev-class="'page-link'"
                              :prev-text="'Prev'">
                    </paginate>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import XLSX from "xlsx";

    export default {
        name: "Warehouses",
        components: {Paginate},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                warehouses: [],
                pageCount: 1,
                total: 0,
                perPage: 10,
                search: null,
                exporting: false
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getWareHouses(1);
            },
            async getWareHouses(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                            params: {
                                page: page,
                                perPage: this.perPage,
                                search: this.search
                            }
                        });
                    $(".preloader").fadeOut();
                    this.total = reply.data.total;
                    this.warehouses = reply.data.warehouses;
                    this.setPageCount();
                } catch (e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getWareHouses(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            async reset() {
                this.search = null;
                await this.getWareHouses()
            },
            perPageRecordChange() {
                if (this.isFiltered) {
                    this.getWareHouses(1);
                } else {
                    this.getWareHouses(1);
                }
            },
            async exportWHAsExcel() {
                try {
                    this.exporting = true;

                    let reply = await this.$http
                        .get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                            params: {
                                page: 1,
                                perPage: this.total,
                                search: this.search
                            }
                        });
                    let data = reply.data.warehouses;
                    let warehouses = [];
                    data.forEach(d => {
                        warehouses.push({
                            "ID": d.id,
                            "Name": d.name,
                            "Description": d.description,
                            "Address Line1": d.line1,
                            "Address Line2": d.line2,
                            "City": d.city,
                            "State": d.state,
                            "Postal Code": d.postal_code,
                            "Country": d.country
                        })
                    });

                    let workbook = XLSX.utils.book_new();
                    let worksheet = XLSX.utils.json_to_sheet(warehouses);
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Warehouses');
                    XLSX.writeFile(workbook, 'warehouses.xlsx');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
